import { Award, CheckCircle, FileCheck, Shield, TrendingUp } from "lucide-react";
import ApplicationPage, { type ApplicationPageConfig } from "@/components/ApplicationPage";

const config: ApplicationPageConfig = {
  key: "quality",
  slug: "qualidade",
  icon: Award,
  useCases: [
    { key: "nonConformities", icon: CheckCircle },
    { key: "isoDocuments", icon: FileCheck },
    { key: "audits", icon: Shield },
    { key: "kpis", icon: TrendingUp },
  ],
  benefits: ["reduction", "iso", "audits", "visibility"],
  formApplication: "Qualidade",
};

const Qualidade = () => <ApplicationPage config={config} />;

export default Qualidade;
